import type { PersonaMetadata } from "@/types/api/Persona"

export const BACKGROUND_SOUND_OFF_VALUE = "off"

type BackgroundSoundStatus = "active" | "archived"

interface BackgroundSoundArchiveSelectionOptions {
  currentBackgroundSoundValue: string | undefined
  selectedSoundValue: string
  status: BackgroundSoundStatus
}

export function getBackgroundSoundSelectionPatchAfterStatusChange({
  currentBackgroundSoundValue,
  selectedSoundValue,
  status,
}: BackgroundSoundArchiveSelectionOptions): Partial<PersonaMetadata> {
  if (
    status === "archived" &&
    currentBackgroundSoundValue === selectedSoundValue
  ) {
    return {
      background_sound: BACKGROUND_SOUND_OFF_VALUE,
      background_sound_volume: undefined,
    }
  }

  return {}
}
